import React from "react";
import { Card, Typography, LinearProgress, Box } from "@mui/material";
import AppButton from "../../../../components/buyer/AppButton";

const ProfileCompletionSection = ({ completion, onNavigateProfile, theme }) => (
  <Card
    sx={{
      p: 3, // Padding for smaller screens
      borderRadius: 3,
      height: "auto", // Ensure the height is auto to remove unnecessary space at the bottom
      width: "100%",
      background: "#fffef7",
      boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
      border: "1px solid rgba(0,0,0,0.04)",
      // display: "flex",
      flexDirection: "column", // Ensure column layout to stack elements vertically
      justifyContent: "space-between", // Distribute space between elements
      "@media (min-width:600px)": {
        p: 4, // Padding adjustment for medium screens
      },
      "@media (min-width:900px)": {
        p: 5, // Padding adjustment for larger screens
      },
    }}
  >
    <Typography
      variant="h5"
      fontWeight={600}
      mb={1} // Reduced margin for mobile
      sx={{
        fontSize: { xs: "1.2rem", sm: "1.5rem" }, // Responsive font size
      }}
    >
      Profile Completion
    </Typography>

    <Typography
      variant="body2"
      color="text.secondary"
      mb={1} // Reduced margin at the bottom of the description text
      sx={{
        fontSize: { xs: "0.9rem", sm: "1rem" }, // Adjust font size on small screens
      }}
    >
      Your profile is {completion}% complete.
    </Typography>

    <LinearProgress
      variant="determinate"
      value={completion}
      sx={{
        height: 10,
        borderRadius: 2,
        mb: 1, // Reduced margin below the progress bar
        background: "#f3f3f3",
      }}
    />

    <AppButton
      onClick={onNavigateProfile}
      style={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.info.contrastText,
        border: "none",
        width: {
          xs: "80%", // Full width on small screens
          sm: "60%", // 60% width on medium screens
          md: "40%", // 40% width on larger screens
        },
        margin: "auto",
      }}
    >
      Complete Profile
    </AppButton>
    
  </Card>
);

export default ProfileCompletionSection;
